import { useEffect } from 'react'
import { CuiButton } from 'front-lib'

import { useTrackMembershipModal } from '../../useTrackMembershipModal'
import { MEMBERSHIP_MODAL_STEPS } from 'src/modules/Modals/constants'
import {
  Step,
  MembershipData,
  MembershipOverlayName,
  MembershipOverlayActions
} from 'src/types/membership'

import './MembershipIntroduction.scss'
import { FF_ENABLE_UNITY_HUB_REJOIN } from 'src/constants/feature-flags'
import { useFlag } from '@unleash/proxy-client-react'
import { useHistory } from 'react-router-dom'
import { RoutePaths } from 'src/routes/routePaths'
interface Props {
  onContinue: (step: Step) => void
  membershipData?: MembershipData
  handleClose?: () => void
}

export function MembershipIntroduction({
  onContinue,
  membershipData,
  handleClose
}: Readonly<Props>) {
  const { trackModalViewed, trackOptionClicked } = useTrackMembershipModal({
    overlayName: MembershipOverlayName.introduction
  })
  const unityHubRejoinIsEnabled = useFlag(FF_ENABLE_UNITY_HUB_REJOIN)

  const isTrial = membershipData?.activation?.isTrial
  const hasStopDate = membershipData?.activation?.stopDate
  const history = useHistory()

  useEffect(() => {
    trackModalViewed()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const copy = {
    trial: {
      title: 'Enjoy a free month of UnityPass',
      subtitle: 'Our gift to you!',
      description: `You’re already getting free delivery, exclusive discounts, and 10 points to unlock events, exclusive benefits, and perks. ${
        hasStopDate
          ? `If you do not decide to renew UnityPass next month, UnityPass will be deactivated automatically - no charges applied`
          : 'No need to do anything — your benefits will continue automatically after the trial. Cancel anytime before your trial ends to avoid being charged.'
      }`,
      buttonText: 'Explore UnityPass'
    },
    default: {
      title: 'Introducing UnityPass:',
      subtitle: 'Save more, savor more!',
      description: `Start enjoying free delivery, exclusive discounts, and three premium meals per order at no extra cost for only $${membershipData?.membership?.cost}/month.`,
      buttonText: 'Discover UnityPass benefits'
    }
  }

  const currentCopy = isTrial ? copy.trial : copy.default

  function handleContinue() {
    if (unityHubRejoinIsEnabled) {
      handleClose?.()
      history.push(RoutePaths.UNITYPASS_HUB)
    } else {
      trackOptionClicked({ overlayAction: MembershipOverlayActions.discover })
      onContinue(MEMBERSHIP_MODAL_STEPS.benefits)
    }
  }

  return (
    <>
      <div className="unity-pass-banner" />
      <div className="introduction-container">
        <div className="title-container">
          <span className="title">{currentCopy.title}</span>
          <span className="subtitle">{currentCopy.subtitle}</span>
        </div>
        <div className="description-container">
          <span className="description">{currentCopy.description}</span>
        </div>
        <div className="introduction-buttons">
          <CuiButton onClick={handleContinue}>
            {currentCopy.buttonText}
          </CuiButton>
        </div>
      </div>
    </>
  )
}
